import styled from 'styled-components';
import {
  OutlinedInput, Avatar, FormControl, Alert,
} from '@mui/material';

import { Styling, Colors } from '../../../../constants';
import CheckBoxSelect from '../../../Shared/CheckBoxSelect';

const teamSize = 24;
const labelWidth = 100;
const labelRightMargin = Styling.DEFAULT_SPACING;
const valueRowHeight = 51;

const contentSpacing = `0 ${Styling.DEFAULT_SPACING_DOUBLED + 2}px 0 ${labelWidth + labelRightMargin + Styling.DEFAULT_SPACING_DOUBLED}px`;

export const TeamContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TeamActionContainer = styled(TeamContainer)`
  button.active {
    color: ${Colors.RED_1};
  }
`;

export const ProgressContainer = styled.div`
  height: 4px;
`;

export const ControlContainer = styled.div`
  align-items: center;
  display: flex;
  margin: ${Styling.DEFAULT_SPACING}px 0 ${Styling.DEFAULT_SPACING_HALVED}px;
  padding: 0 ${Styling.DEFAULT_SPACING_DOUBLED}px;
`;

export const Label = styled.div`
  margin-right: ${labelRightMargin}px;
  text-align: center;
  width: ${labelWidth}px;
`;

export const Input = styled(OutlinedInput)`
  flex-grow: 1;
`;

export const WarnContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding: ${contentSpacing};
`;

export const ChipContainer = styled.div`
  margin: ${contentSpacing};
  padding: ${Styling.DEFAULT_SPACING}px;
  display: flex;
  overflow: auto;
`;

export const Value = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 10px;
  padding-top: 1px;
`;

export const ValuesContainer = styled.div`
  min-height: ${valueRowHeight * 2}px;
  max-height: ${valueRowHeight * 4}px;
  padding: 0 ${Styling.DEFAULT_SPACING_DOUBLED + 2}px 0 ${labelWidth + labelRightMargin + Styling.DEFAULT_SPACING_DOUBLED}px;
  overflow: overlay;
`;

export const StyledAvatar = styled(Avatar)`
  width: ${teamSize}px !important;
  height: ${teamSize}px !important;
  margin-right: ${Styling.DEFAULT_SPACING}px;
`;

const InfoContainer = styled(Alert).attrs({
  severity: 'info' as const,
})`
  margin: ${Styling.DEFAULT_SPACING}px auto ${Styling.DEFAULT_SPACING_HALVED}px auto;
  padding: ${contentSpacing};
  padding: ${Styling.DEFAULT_SPACING}px;
  justify-content: center;
`;

export {
  InfoContainer,
};

export const QualifierSelect = styled(FormControl)`
  width: 100%;
  & > .MuiFormLabel-root {
    top: -4px;
    left: 9px;
  }
  & > .MuiFormLabel-root.Mui-focused, & > .MuiFormLabel-root.MuiFormLabel-filled {
    padding-top: 4px;
    padding-left: 4px;
    top: 0;
    left: 0;
  }
`;

export const TeamGamePartContainer = styled.div`
  width: 350px;  
`;

export const DefaultGamePartContainer = styled.div`
  flex-grow: 1;
`;
